let adminBase = window._env_.VUE_APP_ADMIN_HOST



export const getStoreCollectionTable = params => {
  return axios.get(`${adminBase}/market_gatherinfo/query`, {params})
}
export const exportStoreCollectionTable = params => {
  return axios.get(`${adminBase}/market_gatherinfo/export`, {params})
}



// WEBPACK FOOTER //
// ./src/views/store-collection/store-collection.api.js